module.exports = __webpack_public_path__ + "img/close.51c29a0c.svg";